import cookies from 'js-cookie'

import {LOGIN_COOKIE_KEY} from './constants'

let path = null
const CookieService = {
    getSessionCookie: () => {
        const v = cookies.get(LOGIN_COOKIE_KEY, {path: path})
        return v ? v : null
    },
    setSessionCookie: (cookie) => {
        const v = cookies.set(LOGIN_COOKIE_KEY, cookie, {path: path})
        return v ? v : null
    },

    removeSessionCookie: () => {
        cookies.remove(LOGIN_COOKIE_KEY, {path: path})
    },
    setCookiePath: (newPath) => {
        path = `/${newPath}`;
        console.log(`Cookie path: ${path}`);
    }
};

export default CookieService

